import { StProgressBar, StProgressBarContainer } from './ProgressBar.styled'

import type { ProgressBarProps, ProgressBarTheme } from './ProgressBar.types'

const ProgressBar = ({
  min,
  max,
  value,

  ...themeProps
}: ProgressBarProps & Partial<ProgressBarTheme>) => {
  return (
    <StProgressBarContainer aria-valuemin={min} aria-valuemax={max} aria-valuenow={value} {...themeProps}>
      <StProgressBar percentage={((value - min) / (max - min)) * 100} {...themeProps} />
    </StProgressBarContainer>
  )
}

export { ProgressBar }
